import { css } from '@emotion/react';

const collapsedChargeStyles = {
    charge: css({
        backgroundColor: '#ffffff',
        borderTopLeftRadius: '8px',
        borderBottomLeftRadius: '8px',
        paddingRight: '12px',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        borderRight: '2px solid #EDEDED',

        '@media (min-width: 600px)': {
            padding: '8px',
        },
    }),
    chargeTitle: css({
        fontSize: '12px',
        fontWeight: '700',
        color: '#000000',
        marginRight: '33px',
        display: 'flex',
        alignItems: 'center',
    }),
    titleBlock: css({
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
    }),
    chargeValuesBlock: css({
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-end',
        marginRight: '4px',
    }),
    chargeValuesLine: css({
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        fontSize: '10px',
        lineHeight: '10px',
        fontWeight: '500',
        color: '#000000',
    }),
    chargeValue: css({
        fontWeight: '700',
        marginRight: '2px',
    }),
}

export default collapsedChargeStyles;